// extracted by mini-css-extract-plugin
export var circle = "_e2-1";
export var exitConfirmationModal = "_e2-5";
export var iframe = "_e2-0";
export var offline = "_e2-3";
export var online = "_e2-2";
export var workstationSelectError = "_e2-4";